import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNewSend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 14 12",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 4.66667L9.81151 5.99933L0 7.33333L0.00719511 12L13.7355 5.99933L0.00719511 0L0 4.66667Z"
	})
});
export default SvgNewSend;
